import {Component, ViewChild, Injectable} from '@angular/core';
import {
  ActionSheetController, Content, FabContainer, IonicPage, ModalController, NavController,
  NavParams
} from 'ionic-angular';
import {Platform, MenuController, App} from 'ionic-angular';
import {ServiceProvider} from '../../providers/service/service';
import {Storage} from '@ionic/storage';
import {AlertController, Nav, ToastController, LoadingController} from 'ionic-angular';
import {EnquiryFormPage} from "../enquiry-form/enquiry-form";
import {SocialSharing} from '@ionic-native/social-sharing';
import {AddAppointmentPage} from "../add-appointment/add-appointment";
import {DomSanitizer} from "@angular/platform-browser";
import {WebIntent} from '@ionic-native/web-intent';
import {DataCallLogPage} from "../data-call-log/data-call-log";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {ListDataModelPage} from "../list-data-model/list-data-model";

import {Contacts, Contact, ContactName, ContactField} from '@ionic-native/contacts';

import {FileTransfer, FileUploadOptions, FileTransferObject} from "@ionic-native/file-transfer";
import {File} from "@ionic-native/file";

import moment from 'moment';
import {NonenquirylogPage} from "../nonenquirylog/nonenquirylog";
import {Sim} from "@ionic-native/sim";
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {DailyCallLogsPage} from "../daily-call-logs/daily-call-logs";
import {SubStatusHistoryPage} from "../sub-status-history/sub-status-history";
import {EnquirystatusPage} from "../enquirystatus/enquirystatus";
import {EnquiryresponsePage} from "../enquiryresponse/enquiryresponse";
import {ParentFeedbackPage} from "../parent-feedback/parent-feedback";
import {EnquiryRemarkPage} from "../enquiry-remark/enquiry-remark";
import {CallStatusIsNullPage} from "../call-status-is-null/call-status-is-null";
import {AddCallReminderPage} from "../add-call-reminder/add-call-reminder";
import {AddJustdialDataPage} from "../add-justdial-data/add-justdial-data";
import {DataLogPage} from "../data-log/data-log";
import {PredataCallLogsPage} from "../predata-call-logs/predata-call-logs";

//@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {
  @ViewChild(Content)
  content: Content;
  FUserId: any;
  userName: any;
  UserRights: any;
  SchoolData = {};
  TypeData = {};
  School = 'All';
  CommonTypeId = 'Web_Enquiry';
  FilterOption = 'Date';
  Date: any;
  DisplayDate = "";
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  items = [];
  page = 1;
  EnqData = [];
  EnquiryData = [];
  EnquiryData1 = [];
  DataSearch: any;
  datanotfound: any;
  statusbar = 'All';
  StatusData = {};


  SubStatus: any;
  SubStatusItem: any;

  AllotedMobileNumber: any;
  simPhoneNumbers: any[];
  global: any;

  //count
  CountAll: any;
  CountGuestJd: any;
  CountDataAdded: any;
  CountApmtBooked: any;
  CountEnqAttended: any;
  CountFeedbackSubmitted: any;
  CountAdmissionDone: any;
  CountArchive: any;
  DataSourceAll: any;
  DataSourceGoogle: any;
  DataSourceDirect: any;
  DataSourceWebsite: any;
  DataSourceJustDailEnq: any;
  DataSourceOthers: any;
  DataSubstatusAll: any;
  DataSubstatusNoCallsYet: any;
  DataSubstatusNoConvo: any;
  DataSubstatusApmtPndng: any;
  DataSubstatusJustDailEnq: any;
  DataEnqStatus_All: any;
  DataEnqStatus_Def: any;
  DataEnqStatus_Adm: any;
  DataEnqStatus_Think: any;
  DataEnqStatus_Prb: any;
  DataEnqStatus_Fdbk: any;
  DataEnqStatus_Mgmt: any;
  DataEnqStatus_CNC: any;

  IsSearch = 0;
  CallFor = 1;

  ArchiveStatus: any;
  ArchiveStatusItem: any;
  DataSubstatustab = 'All';
  DataSubstatustabData = {};

  //all
  DataSourcetab = 'All';
  DataSourcetabData = {};

  //apmt
  AppointmentData = [];
  AptStatus = 'Open';
  AptStatusData = {};
  Reasons: any;
  OpenCount: any;
  TodayCount: any;
  TomorrowCount: any;
  PastCount: any;
  CancelledCount: any;
  AptDataSearch: any;

  //Enquiry
  Enq_tab = 'All';
  EnqEnquiryData: any;
  EnqEnquiryData1: any;
  SchoolName = 'WWGS/Contact';
  EnqSub_tab = 'All'
  EnqSubData = {};


  FbStatus = 'All';
  FeedbackStatusData: any;
  FeedbackData: any;
  FeedbackData1: any;
  shownGroup: any;

  CountFbStatusYes: any;
  CountFbStatusNo: any;
  CountFbStatusMaybe: any;
  CountFbStatusAdmDone: any;


  AdmStatus = 'All';
  AdmEnquiryData: any;
  AdmEnquiryData1: any;

  //Archive
  ArchiveType = 'All';
  ArchiveTypeData = {};
  CountAllArchive: any;
  CountAdmAntrArchive: any;
  CountNtVirArchive: any;
  CountTrnsptArchive: any;
  CountTestArchive: any;
  CountNtIntArchive: any;
  CountOthersArchive: any;


  //GuestJd
  GuestJdSatus = 'Pending';
  IsArchiveData = {};


  constructor(public actionSheetCtrl: ActionSheetController,
              public navCtrl: NavController,
              public navParams: NavParams,
              public service: ServiceProvider,
              public platform: Platform,
              menuCtrl: MenuController,
              public loadingCtrl: LoadingController,
              public toastCtrl: ToastController,
              private androidPermissions: AndroidPermissions,
              public storage: Storage,
              public _app: App,
              public modalCtrl: ModalController, public alertCtrl: AlertController,
              private contacts: Contacts,
              private sanitizer: DomSanitizer,
              private socialSharing: SocialSharing,
              public iab: InAppBrowser,
              private webIntent: WebIntent,
              public file: File,
              private transfer: FileTransfer,
              public sim: Sim) {
    this.platform.ready().then(() => {
      Promise.all([this.storage.get('LoginData'), this.storage.get('AllotedMobileNumber'), this.storage.get('UserData')]).then(values => {
        this.FUserId = values[0]['FUserId'];
        this.userName = values[2]['Name'];
        this.AllotedMobileNumber = values[1];
        console.log(this.FUserId);
        // this.open_enquiry_form(null);
        this.get_user_rights(this.FUserId);


        this.Date = new Date();
        this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear();
        this.Date = this.Date.toISOString();


        this.SchoolData = {
          "All": 0,
          "GWW": 2,
          "GWE": 3,
          "GEIS": 1
        };

        this.StatusData = {
          "All": 0,
          "DataAdded": 1,
          "AppointmentBooked": 2,
          "EnquiryAttended": 3,
          "FeedbackSubmitted": 4,
          "AdmissionDone": 5,
          "Archive": 6,
          "Testing": 7
        }

        this.AptStatusData = {
          "Open": 1,
          "Cancelled": 2,
          "Today": 3,
          "Tomorrow": 4,
          "Past": 5
        };

        this.DataSubstatustabData = {
          "All": 0,
          "NoCallsYet": 1,
          "NoConvo": 2,
          "ApmtPndng": 3,
          "JustDailEnq": 4
        };

        this.DataSourcetabData = {
          "All": 0,
          "Google": 1,
          "Direct": 2,
          "Website": 3,
          "JustDailEnq": 4,
          "Others": 5
        };

        this.FeedbackStatusData = {
          "All": 0,
          "Yes": 1,
          "No": 2,
          "MayBe": 3,
          "AdmDone": 4
        };

        this.ArchiveTypeData = {
          "All": 0,
          "AdmAntr": 1,
          "NtVir": 2,
          "Trnspt": 3,
          "Test": 4,
          "NtInt": 5,
          "Others": 6
        };

        this.EnqSubData = {
          "All": 0,
          "Def": 1,
          "Adm": 2,
          "Think": 3,
          "Prb": 4,
          "Fdbk": 5,
          "Mgmt": 6,
          "CNC": 7
        };

        this.IsArchiveData = {
          "Pending": 1,
          "Archive": 3,
        };


        this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        this.loadDataCount(this.SchoolData[this.School]);
        this.createFolderArcyle();
        // this.getPhoneNumber();
        this.getIncoming();
        this.getOutGoing();
        this.load_archive_status();
        this.loadDataCount(this.SchoolData[this.School]);
        // this.getSubStatus();


      });
    });
    this.platform.resume.subscribe(async () => {
      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
      this.loadDataCount(this.SchoolData[this.School]);
      this.createFolderArcyle();
      // this.getPhoneNumber();
      this.getIncoming();
      this.getOutGoing();
      this.loadDataCount(this.SchoolData[this.School]);
    });
  }

  ionViewWillEnter() {

    console.log('ionViewWillEnter HomePage');
  }

  open_enquiry_form(item) {
    console.log("item->", item);
    let Sibling = 0;
    let Jd = null;
    if (item) {
      Sibling = 1;
    }
    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {Siblings: Sibling, SiblingsData: item});
    EnquiryModel.onDidDismiss(data => {
      console.log(data);
      if (data == undefined) {

      } else {
        this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        this.loadDataCount(this.SchoolData[this.School]);
        this.presentToast(data);
      }

      // this.checkCallStatusIsNull();

    });
    EnquiryModel.present();
  }

  checkCallStatusIsNull() {

    this.service.httpcall('web_service/get_FCallStatus_isNULL_webEnquiry?Check=1').subscribe(data => {
      console.log("getNullCallData", data);

      if (data['response'] == "success") {
        console.log("if");

        let alert = this.alertCtrl.create({
          title: 'Call Status Alert!',
          message: 'You have to set call status.',
          buttons: [
            {
              text: 'Set Call Status',
              handler: () => {
                console.log('click on set');
                this.navCtrl.push(CallStatusIsNullPage, {Alldata: data['Data']})

              }
            }
          ]
        });
        alert.present();

      } else {
        console.log("else");

      }
    });

  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  add_filter(f) {
    console.log(f);
    if (f == 'All') {
      this.FilterOption = 'All';
      this.DisplayDate = "";

      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
    } else {
      this.FilterOption = 'Date';
      var Date1 = new Date(this.Date);
      console.log(Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
      this.DisplayDate = Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
      console.log("DisplayDate ", this.DisplayDate);

      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
      console.log('Date call');
    }
  }

  Prev(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) - 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Next(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) + 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }


  get_user_rights(FUserId) {
    this.service.httpcall('web_service/get_users_rights?FUserId=' + FUserId).subscribe(data => {
      console.log(data['RightsData']);
      this.UserRights = data['RightsData'];
      if (this.UserRights != undefined) {
        console.log(this.School)

        this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
      }
    })
  }

  active_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.CommonTypeId = 'Web_Enquiry';
    this.loadDataCount(this.SchoolData[this.School]);
    this.active_statustab(this.statusbar);
    // this.EnquiryData=[];
    // this.page=1;
    // this.IsSearch=0;
    // this.DataSearch=null;
    // this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate,this.StatusData[this.statusbar],this.page);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  active_statustab(tab) {
    console.log(tab);
    this.statusbar = tab;
    if (this.statusbar == 'All') {
      this.active_DataSourcetab(this.DataSourcetab)
    } else if (this.statusbar == 'GuestJd') {
      this.active_GuestJd_tab(this.GuestJdSatus);
    } else if (this.statusbar == 'DataAdded') {
      this.active_DataSubstatustab(this.DataSubstatustab)
    } else if (this.statusbar == 'AppointmentBooked') {
      this.Apmt_getReasons();
      this.AptStatusactive_tab(this.AptStatus);
    } else if (this.statusbar == 'EnquiryAttended') {
      this.active_Enq_tab(this.Enq_tab);
    } else if (this.statusbar == 'FeedbackSubmitted') {
      this.active_fbstatus_tab(this.FbStatus);
    } else if (this.statusbar == 'AdmissionDone') {
      this.active_Adm_sub_tab(this.AdmStatus);
    } else if (this.statusbar == 'Archive') {
      this.active_archiveType_tab(this.ArchiveType);
    } else {
      this.EnquiryData = [];
      this.page = 1;
      this.IsSearch = 0;
      this.DataSearch = null;
      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
    }
    this.loadDataCount(this.SchoolData[this.School]);
  }

  active_DataSourcetab(tab) {
    console.log(tab);
    this.DataSourcetab = tab;
    console.log(this.DataSourcetabData[this.DataSourcetab]);

    this.EnquiryData = [];
    this.page = 1;
    this.IsSearch = 0;
    this.DataSearch = null;
    this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
  }

  active_DataSubstatustab(tab) {
    console.log(tab);
    this.DataSubstatustab = tab;
    console.log(this.DataSubstatustabData[this.DataSubstatustab]);

    this.EnquiryData = [];
    this.page = 1;
    this.IsSearch = 0;
    this.DataSearch = null;
    this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
  }

  active_Enq_tab(tab) {
    console.log(tab);
    this.Enq_tab = tab;
    if (this.Enq_tab == 'All') {
      this.active_EnqSub_tab(this.EnqSub_tab);
    } else {
      this.loadEnqvalues(this.SchoolData[this.School], this.statusbar, this.FUserId, this.DisplayDate);
    }
  }

  active_EnqSub_tab(tab) {
    this.EnqSub_tab = tab;
    console.log(this.EnqSubData[this.EnqSub_tab]);
    this.EnquiryData = [];
    this.page = 1;
    this.IsSearch = 0;
    this.DataSearch = null;
    this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
  }

  AptStatusactive_tab(tab) {
    console.log(tab);
    this.AptStatus = tab;
    this.CommonTypeId = 'Web_Enquiry';
    this.AppointmentData = [];
    this.page = 1;
    this.IsSearch = 0;
    this.DataSearch = null;
    this.Apmt_getReasons();
    this.loadApmtCountvalues(this.SchoolData[this.School]);
    this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  active_archiveType_tab(tab) {
    console.log(tab);
    this.ArchiveType = tab;
    this.loadArchiveCount(this.SchoolData[this.School]);
    this.EnquiryData = [];
    this.page = 1;
    this.IsSearch = 0;
    this.DataSearch = null;
    this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);

  }

  loadDataCount(FSchoolId) {

    this.CountAll = null;
    this.CountGuestJd = null;
    this.CountDataAdded = null;
    this.CountApmtBooked = null;
    this.CountEnqAttended = null;
    this.CountFeedbackSubmitted = null;
    this.CountAdmissionDone = null;
    this.CountArchive = null;
    this.DataSourceAll = null;
    this.DataSourceGoogle = null;
    this.DataSourceDirect = null;
    this.DataSourceWebsite = null;
    this.DataSourceJustDailEnq = null;
    this.DataSourceOthers = null;
    this.DataSubstatusAll = null;
    this.DataSubstatusNoCallsYet = null;
    this.DataSubstatusNoConvo = null;
    this.DataSubstatusApmtPndng = null;
    this.DataSubstatusJustDailEnq = null;
    this.DataEnqStatus_All = null;
    this.DataEnqStatus_Def = null;
    this.DataEnqStatus_Adm = null;
    this.DataEnqStatus_Think = null;
    this.DataEnqStatus_Prb = null;
    this.DataEnqStatus_Fdbk = null;
    this.DataEnqStatus_Mgmt = null;
    this.DataEnqStatus_CNC = null;

    this.service.httpcall('web_service/get_web_enquiry_data_count?FSchoolId=' + FSchoolId).subscribe(data => {

      console.log(data);
      this.CountAll = data['All'];
      this.CountGuestJd = data['CountGuestJd'];
      this.CountDataAdded = data['DataAdded'];
      this.CountApmtBooked = data['ApmtBooked'];
      this.CountEnqAttended = data['EnqAttended'];
      this.CountFeedbackSubmitted = data['FeedbackSubmitted'];
      this.CountAdmissionDone = data['AdmissionDone'];
      this.CountArchive = data['Archive'];
      this.DataSourceAll = data['DataSourceAll'];
      this.DataSourceGoogle = data['DataSourceGoogle'];
      this.DataSourceDirect = data['DataSourceDirect'];
      this.DataSourceWebsite = data['DataSourceWebsite'];
      this.DataSourceJustDailEnq = data['DataSourceJustDailEnq'];
      this.DataSourceOthers = data['DataSourceOthers'];
      this.DataSubstatusAll = data['DataSubstatusAll'];
      this.DataSubstatusNoCallsYet = data['DataSubstatusNoCallsYet'];
      this.DataSubstatusNoConvo = data['DataSubstatusNoConvo'];
      this.DataSubstatusApmtPndng = data['DataSubstatusApmtPndng'];
      this.DataSubstatusJustDailEnq = data['DataSubstatusJustDailEnq'];
      this.DataEnqStatus_All = data['DataEnqStatus_All'];
      this.DataEnqStatus_Def = data['DataEnqStatus_Def'];
      this.DataEnqStatus_Adm = data['DataEnqStatus_Adm'];
      this.DataEnqStatus_Think = data['DataEnqStatus_Think'];
      this.DataEnqStatus_Prb = data['DataEnqStatus_Prb'];
      this.DataEnqStatus_Fdbk = data['DataEnqStatus_Fdbk'];
      this.DataEnqStatus_Mgmt = data['DataEnqStatus_Mgmt'];
      this.DataEnqStatus_CNC = data['DataEnqStatus_CNC'];

    })
  }

  loadArchiveCount(FSchoolId) {
    this.service.httpcall('web_service/get_archive_webenquiry_count?FSchoolId=' + FSchoolId).subscribe(data => {

      console.log(data);
      this.CountAllArchive = data['CountAllArchive'];
      this.CountAdmAntrArchive = data['CountAdmAntrArchive'];
      this.CountNtVirArchive = data['CountNtVirArchive'];
      this.CountTrnsptArchive = data['CountTrnsptArchive'];
      this.CountTestArchive = data['CountTestArchive'];
      this.CountNtIntArchive = data['CountNtIntArchive'];
      this.CountOthersArchive = data['CountOthersArchive'];

    })
  }

  send_location(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Select School',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Select',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            this.select_contact_to_send_location(data, item);
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: "GEIS",
      value: '1'
    })
    myAlert.addInput({
      type: 'radio',
      label: "GWW",
      value: '2'
    })
    myAlert.addInput({
      type: 'radio',
      label: "GWE",
      value: '3'
    })
    myAlert.present();

  }

  select_contact_to_send_location(schoolid, item) {
    let myAlert = this.alertCtrl.create({
      title: 'Send Whatsapp Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);

            let location = null;
            if (schoolid == '1') {
              location = item.GEISLocation;
            }
            if (schoolid == '2') {
              location = item.GWWLocation;
            }
            if (schoolid == '3') {
              location = item.GWELocation;
            }

            console.log("location -> ", location);

            //window.location.href = 'whatsapp://send?phone=+91' + data+'&text='+this.sanitize(link);
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, "", null, location);
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();
  }


  //=========FBStatus===============

  active_fbstatus_tab(tab) {
    console.log(tab);
    this.FbStatus = tab;
    this.loadFbCountvalues(this.SchoolData[this.School]);
    if (this.FbStatus != 'All') {
      console.log(this.FbStatus + " " + this.FeedbackStatusData[this.FbStatus]);
      this.loadFbvalues(this.SchoolData[this.School], this.FUserId, this.FeedbackStatusData[this.FbStatus]);
      this.loadFbCountvalues(this.SchoolData[this.School]);
    } else {
      this.EnquiryData = [];
      this.page = 1;
      this.IsSearch = 0;
      this.DataSearch = null;
      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
    }

  }

  loadFbvalues(FSchoolId, FUserId, FeedbackStatus) {
    this.FeedbackData = [];
    this.datanotfound = null;
    console.log("FSchoolId", FSchoolId);
    this.service.httpcall('web_service/get_feedback_school_id?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&FeedbackStatus=' + FeedbackStatus).subscribe(data => {
      // loading.dismiss();
      console.log(data);
      if (data['response'] == "success") {
        this.datanotfound = null;

        this.FeedbackData1 = data['data'];
        this.FeedbackData = this.FeedbackData1;

        console.log(this.FeedbackData);
      } else {
        this.datanotfound = data['error_description'];
      }

    })
  }

  loadFbCountvalues(FSchoolId) {
    this.service.httpcall('web_service/get_feedback_count?FSchoolId=' + FSchoolId).subscribe(data => {
      // loading.dismiss();
      console.log(data);
      this.CountFbStatusYes = data['CountFbStatusYes'];
      this.CountFbStatusNo = data['CountFbStatusNo'];
      this.CountFbStatusMaybe = data['CountFbStatusMaybe'];
      this.CountFbStatusAdmDone = data['CountFbStatusAdmDone'];
    })
  }

  searchFbData(ev: any) {
    // Reset items back to all of the items
    this.FeedbackData = this.FeedbackData1;
    // set val to the value of the searchbar
    let val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.FeedbackData = this.FeedbackData.filter((item) => {
        return (item.Description.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }

  }

  Fb_get_color(ans) {
    if (ans == 'Yes') {
      return 'green-color';
    } else if (ans == 'No') {
      return 'red-color';
    } else if (ans == 'May Be') {
      return 'yellow-color';
    }

  }

  Fb_get_management_color(ans) {
    if (ans == 'Yes') {
      return 'blue-color';
    } else if (ans == 'No') {
      return 'brown-color';
    } else {
      return 'green-color1';
    }
  }

  Fb_toggleGroup(group) {
    if (this.Fb_isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  }

  Fb_isGroupShown(group) {
    return this.shownGroup === group;
  }

  Fb_enquiry_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            // window.location.href = 'tel:'  + data;

            let loading = this.loadingCtrl.create({
              content: 'Loading',
              enableBackdropDismiss: false
            });
            loading.present();


            var formdata = new FormData();
            formdata.append("FWebEnquiryId", enquirydata.FWebEnquiryId);
            formdata.append("AddedBy", this.FUserId);
            formdata.append("CallTo", data);
            formdata.append("CallType", "2");
            formdata.append("FileName", "text");
            // formdata.append("CallFor",this.CallFor);


            this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
              console.log(resdata);
              if (resdata['response'] == 'success') {

                var LogId = resdata['LogId'];
                if (loading)
                  loading.dismiss();
                loading = undefined;
                window.location.href = 'tel:' + data;
                // var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
                // const browser = this.iab.create(link,'_system',{location:'no'});
                // window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
              } else {
                if (loading)
                  loading.dismiss();
                loading = undefined;
              }
            }, (err) => {
              if (loading)
                loading.dismiss();
              loading = undefined;
            });

          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.FatherContact,
      value: enquirydata.FatherContact
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MotherContact,
      value: enquirydata.MotherContact
    })
    myAlert.present();
  }

  Fb_go_to_call_logs(item) {
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage, {data: item, Tab: 4});
    // AppointmentModel.onDidDismiss(data => {
    //   console.log(data);
    // });
    Call_logs_model.present();
  }

  Fb_whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'whatsapp://send?phone=+91' + data;
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: enquirydata.FatherContact,
      value: enquirydata.FatherContact
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MotherContact,
      value: enquirydata.MotherContact
    })
    myAlert.present();


  }

  Fb_msg_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'sms:' + data;
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.FatherContact,
      value: enquirydata.FatherContact
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MotherContact,
      value: enquirydata.MotherContact
    })
    myAlert.present();
  }

  //===============End FbStystus=====================

  active_Adm_sub_tab(tab) {
    console.log(tab);
    this.AdmStatus = tab;
    if (this.AdmStatus == 'AllADM') {
      this.EnquiryData = [];
      this.page = 1;
      this.IsSearch = 0;
      this.DataSearch = null;
      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
    } else {
      this.CommonTypeId = tab;
      this.loadvaluesADM(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
    }
  }

  adm_add_filter(f) {
    console.log(f);
    if (f == 'All') {
      this.FilterOption = 'All';
      this.DisplayDate = "";
      this.loadvaluesADM(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
    } else {
      this.FilterOption = 'Date';
      var Date1 = new Date(this.Date);
      console.log((Date1.getDate()) + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
      this.DisplayDate = (Date1.getDate()) + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
      console.log("DisplayDate ", this.DisplayDate);
      this.loadvaluesADM(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);

      console.log('Date call');
    }

  }

  adm_Prev(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) - 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  adm_Next(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) + 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  adm_searchData(ev: any) {
    // Reset items back to all of the items
    this.AdmEnquiryData = this.AdmEnquiryData1;
    // set val to the value of the searchbar
    let val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.AdmEnquiryData = this.AdmEnquiryData.filter((item) => {
        return (item.Description.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }

  }

  adm_msg_Group(item) {

    this.socialSharing.shareViaWhatsApp(item.Description, null, null);

  }

  loadvaluesADM(FSchoolId, FTypeId, FUserId, Date) {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);
    this.AdmEnquiryData = [];
    console.log("FSchoolId", FSchoolId);
    console.log("FTypeId", FTypeId);
    this.service.httpcall('web_service/get_admissions?FSchoolId=' + FSchoolId + '&FTypeId=' + FTypeId + '&FUserId=' + FUserId + '&Date=' + Date).subscribe(data => {
      loading.dismiss();
      console.log(data);
      this.AdmEnquiryData1 = data;
      this.AdmEnquiryData = this.AdmEnquiryData1;

      this.DataSearch = "";
    })
  }


//===============end


  loadvalues(FSchoolId, FUserId, Date, Status, page, DataSubstatus, DataSource, ArchiveType, EnqSubStatus) {
    console.log("DataSubstatus", DataSubstatus);
    // let loading = this.loadingCtrl.create({
    //   content: 'Loading'
    // });
    // loading.present();
    // setTimeout(() => {
    //   loading.dismiss();
    // }, 5000);
    // this.EnquiryData = [];

    if (page == 1) {
      this.EnquiryData = [];
    }

    this.datanotfound = null;
    console.log("FSchoolId", FSchoolId);

    let url = null;

    if (this.statusbar == 'DataAdded') {
      if (DataSubstatus == 0) {
        url = 'web_service/get_webenquiry_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&Active=' + 1 + '&Status=' + Status + '&page=' + page;
      } else {
        url = 'web_service/get_webenquiry_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&Active=' + 1 + '&Status=' + Status + '&page=' + page + '&DataSubstatus=' + DataSubstatus;
      }

    } else if (this.statusbar == 'All') {
      url = 'web_service/get_webenquiry_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&Active=' + 1 + '&Status=' + Status + '&page=' + page + '&DataSource=' + DataSource;
    } else if (this.statusbar == 'EnquiryAttended' && this.Enq_tab == 'All') {
      url = 'web_service/get_webenquiry_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&Active=' + 1 + '&Status=' + Status + '&page=' + page + '&EnqSubStatus=' + EnqSubStatus;
    } else {
      if (Status == 6) {
        url = 'web_service/get_webenquiry_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&Active=' + 3 + '&page=' + page + '&Archive=' + ArchiveType;
      } else {
        url = 'web_service/get_webenquiry_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&Active=' + 1 + '&Status=' + Status + '&page=' + page;
      }
    }


    this.service.httpcall(url).subscribe(data => {

      // if(loading)
      //   loading.dismiss();
      // loading = undefined;

      console.log(data);
      if (data['response'] == "success") {
        this.datanotfound = null;

        // this.EnquiryData1 = data['data'];
        for (let i = 0; i < data['data'].length; i++) {
          this.EnquiryData.push(data['data'][i]);
        }
        // this.EnquiryData = this.EnquiryData1;
      } else {
        this.datanotfound = data['error_description'];
      }

    })
  }

  //apmt
  loadApmtvalues(FSchoolId, FUserId, AptStatus, page) {
    this.datanotfound = null;
    console.log("FSchoolId", FSchoolId);
    this.service.httpcall('web_service/get_appointment_by_page?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&AptStatus=' + AptStatus + '&page=' + page).subscribe(data => {
      console.log(data);
      if (data['response'] == "success") {
        this.datanotfound = null;
        for (let i = 0; i < data['data'].length; i++) {
          this.AppointmentData.push(data['data'][i]);
        }
      } else {
        this.datanotfound = data['error_description'];
      }

    })
  }

  loadApmtCountvalues(FSchoolId) {

    console.log("FSchoolId", FSchoolId);
    this.service.httpcall('web_service/get_appointment_count?FSchoolId=' + FSchoolId).subscribe(data => {
      // loading.dismiss();
      console.log(data);
      this.OpenCount = data['OpenCount'];
      this.TodayCount = data['TodayCount'];
      this.TomorrowCount = data['TomorrowCount'];
      this.PastCount = data['PastCount'];
      this.CancelledCount = data['CancelledCount']

    })
  }

  Apmt_enquiry_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            // window.location.href = 'tel:'  + data;

            let loading = this.loadingCtrl.create({
              content: 'Loading',
              enableBackdropDismiss: false
            });
            loading.present();


            var formdata = new FormData();
            formdata.append("FWebEnquiryId", enquirydata.FWebEnquiryId);
            formdata.append("AddedBy", this.FUserId);
            formdata.append("CallTo", data);
            formdata.append("CallType", "2");
            formdata.append("FileName", "text");
            // formdata.append("CallFor",this.CallFor);


            this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
              console.log(resdata);
              if (resdata['response'] == 'success') {
                var LogId = resdata['LogId'];
                if (loading)
                  loading.dismiss();
                loading = undefined;

                window.location.href = 'tel:' + data;

                // var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
                // const browser = this.iab.create(link,'_system',{location:'no'});
                // window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
              } else {
                if (loading)
                  loading.dismiss();
                loading = undefined;
              }
            }, (err) => {
              if (loading)
                loading.dismiss();
              loading = undefined;
            });

          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();
  }

  Apmt_go_to_call_logs(item) {
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage, {data: item, Tab: 2});
    // AppointmentModel.onDidDismiss(data => {
    //   console.log(data);
    // });
    Call_logs_model.present();
  }

  Apmt_whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'whatsapp://send?phone=+91' + data;
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();


  }

  Apmt_msg_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'sms:' + data;
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();
  }

  Apmt_msg_Group(item) {

    this.socialSharing.shareViaWhatsApp(item.SendWhatsAppGroupMsg, null, null);

  }

  Apmt_send_whatsapp(item) {

    let myAlert = this.alertCtrl.create({
      title: 'Send WhatsApp',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'WhatsApp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, "", null, item.SendMsg);

          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();


  }

  Apmt_send_msg(item) {

    let myAlert = this.alertCtrl.create({
      title: 'Send Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            this.socialSharing.shareViaSMS(item.SendMsg, '+91' + data);

          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();


  }

  Apmt_rescheduleApmt(item) {
    let AppointmentModel = this.modalCtrl.create(AddAppointmentPage, {aptData: item});
    AppointmentModel.onDidDismiss(data => {
      console.log(data);
      this.AppointmentData = [];
      this.page = 1;
      this.Apmt_getReasons();
      this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
      this.presentToast(data);
    });
    AppointmentModel.present();
  }

  Apmt_cancelApmt(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Cancel Appointment',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: (data) => {
            console.log('clicked');
            console.log(data);

            this.service.httpcall('web_service/cancelled_appointments?AppointmentId=' + item.Id + "&ReasonId=" + data + "&Bit=0&CancelledBy=" + this.FUserId).subscribe(data => {
              console.log(data);
              if (data['response'] == "success") {
                this.presentToast(data['success_message']);
                this.AppointmentData = [];
                this.page = 1;
                this.Apmt_getReasons();
                this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
              } else {
                this.presentToast(data['error_description']);
              }

            }, (error2 => {
              this.presentToast("Timeout!");
            }))

          }
        }
      ]
    });

    for (var i = 0; i < this.Reasons.length; i++) {
      var edata = this.Reasons[i].Name;
      myAlert.addInput({
        type: 'radio',
        label: edata,
        value: this.Reasons[i].Id
      })
    }


    /*myAlert.addInput({
         type: 'radio',
         label: item.Phone1,
         value: item.Phone1
         })*/

    myAlert.present();
  }

  Apmt_getReasons() {
    this.Reasons = null;
    this.service.httpcall('web_service/get_master_appointment_cancellation_reasons?').subscribe(data => {
      console.log("getReasons", data);
      this.Reasons = data;

    }, (error2 => {
      this.presentToast("Timeout!");
    }))
  }

  Apmt_addSibling(item) {
    let AppointmentModel = this.modalCtrl.create(AddAppointmentPage, {siblingdata: item, sibling: 1});
    AppointmentModel.onDidDismiss(data => {
      console.log(data);
      this.AppointmentData = [];
      this.page = 1;
      this.Apmt_getReasons();
      this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
      this.presentToast(data);
    });
    AppointmentModel.present();
  }

  Apmt_edit_enquiry(item) {
    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {editData: item, IsAppointment: 1});
    EnquiryModel.onDidDismiss(data => {
      console.log(data);
      this.AppointmentData = [];
      this.page = 1;
      this.Apmt_getReasons();
      this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
      this.presentToast(data);
    });
    EnquiryModel.present();
  }

  Apmt_get_enquiry_log(item) {

    this.service.httpcall('web_service/get_web_enquiry_by_school_id?FWebEnquiryId=' + item.FWebEnquiryId).subscribe(data => {

      console.log(data);
      if (data['response'] == "success") {
        let ListModel = this.modalCtrl.create(ListDataModelPage, {data: data['data'], title: "History"});
        ListModel.onDidDismiss(data => {
          console.log(data);
          this.presentToast(data);
        });
        ListModel.present();
      } else {
        this.presentToast(data['error_description']);
      }

    })


  }

  Apmt_add_SubStatus(item) {


    this.SubStatus = null;
    this.SubStatusItem = null;
    this.service.httpcall('web_service/get_master_enquiry_substatus?params[FStatusId]=' + item.Status).subscribe(data => {
      console.log("getReasons", data);
      if (data['response'] == "success") {
        this.SubStatus = data['data'];
        console.log(this.SubStatus);
        let myAlert = this.alertCtrl.create({
          title: 'Set SubStatus',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Confirm',
              handler: (data) => {
                console.log('clicked');
                console.log(data);

                this.service.httpcall('web_service/add_subStatus_On_webEnquiryId?FStatusId=' + item.Status + '&FWebEnquiryId=' + item.FWebEnquiryId + '&FUserId=' + this.FUserId + '&FSubStatusId=' + data).subscribe(data => {
                  console.log(data);
                  if (data['response'] == "success") {
                    this.presentToast(data['success_message']);
                    this.AppointmentData = [];
                    this.page = 1;
                    this.Apmt_getReasons();
                    this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
                  } else {
                    this.presentToast(data['error_description']);
                  }

                }, (error2 => {
                  this.presentToast("Timeout!");
                }))

              }
            }
          ]
        });
        for (var i = 0; i < this.SubStatus.length; i++) {
          this.SubStatusItem = this.SubStatus[i];
          var edata = this.SubStatusItem.SubStatusName;
          console.log(edata);
          myAlert.addInput({
            type: 'radio',
            label: edata,
            value: this.SubStatusItem.Id
          })
        }

        myAlert.present();
      } else {
        this.presentToast(data['error_description']);

      }

    }, (error2 => {
      this.presentToast("Timeout!");

    }))


  }

  Apmt_go_to_SubStatus_hist(item) {
    let SubStatusHistory = this.modalCtrl.create(SubStatusHistoryPage, {FWebEnquiryId: item.FWebEnquiryId});
    SubStatusHistory.onDidDismiss(data => {
      console.log(data);
    });
    SubStatusHistory.present();
  }

  Apmt_select_archive(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Select Archive',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: (data) => {
            console.log('clicked');
            console.log(data);


            let SchoolName = '';
            if (data == 1) {
              let myAlert1 = this.alertCtrl.create({
                title: 'Enter School Name',
                inputs: [
                  {
                    name: 'SchoolName',
                    placeholder: 'School Name'
                  },
                ],
                buttons: [
                  {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                      console.log('Cancel clicked');
                    }
                  },
                  {
                    text: 'Confirm',
                    handler: (data1) => {
                      console.log('clicked');
                      console.log(data1.SchoolName);
                      SchoolName = data1.SchoolName;

                      let loading = this.loadingCtrl.create({
                        content: 'Loading'
                      });
                      loading.present();

                      this.AppointmentData = [];
                      this.datanotfound = null;
                      console.log("Id", item.Id);
                      this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + '&Id=' + item.FWebEnquiryId + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                        if (loading)
                          loading.dismiss();
                        loading = undefined;
                        console.log(data);
                        if (data['response'] == "success") {
                          this.presentToast(data['success_message']);
                          this.AppointmentData = [];
                          this.page = 1;
                          this.Apmt_getReasons();
                          this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
                        } else {
                          this.datanotfound = data['error_description'];
                        }
                      })
                    }
                  }]
              });

              myAlert1.present();
              console.log("Archive1->", data);

            } else {
              let loading = this.loadingCtrl.create({
                content: 'Loading'
              });
              loading.present();

              this.AppointmentData = [];
              this.datanotfound = null;
              console.log("Id", item.Id);
              this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + '&Id=' + item.FWebEnquiryId + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                if (loading)
                  loading.dismiss();
                loading = undefined;
                console.log(data);
                if (data['response'] == "success") {
                  this.presentToast(data['success_message']);
                  this.AppointmentData = [];
                  this.page = 1;
                  this.Apmt_getReasons();
                  this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
                } else {
                  this.datanotfound = data['error_description'];
                }
              })
            }


          }
        }
      ]
    });
    for (var i = 0; i < this.ArchiveStatus.length; i++) {
      this.ArchiveStatusItem = this.ArchiveStatus[i];
      var edata = this.ArchiveStatusItem.Name;
      console.log(edata);
      myAlert.addInput({
        type: 'radio',
        label: edata,
        value: this.ArchiveStatusItem.Id
      })
    }

    myAlert.present();
  }

  searchAptData() {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);

    console.log("Search:", this.AptDataSearch);
    this.AppointmentData = [];
    this.datanotfound = null;

    this.service.httpcall('web_service/get_appointment_by_search?Search=' + this.AptDataSearch + '&FUserId=' + this.FUserId + '&FSchoolId=' + this.SchoolData[this.School] + '&AptStatus=' + this.AptStatusData[this.AptStatus]).subscribe(data => {
      if (loading)
        loading.dismiss();
      loading = undefined;
      console.log(data);
      if (data['response'] == "success") {
        if (loading)
          loading.dismiss();
        loading = undefined;
        this.datanotfound = null;
        this.AppointmentData = data['Data'];
      } else {
        if (loading)
          loading.dismiss();
        loading = undefined;
        this.datanotfound = data['error_description'];
      }

    })
  }

  loadEnqvalues(FSchoolId, FTypeId, FUserId, Date) {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);
    this.EnqEnquiryData = [];
    console.log("FSchoolId", FSchoolId);
    console.log("FTypeId", FTypeId);
    this.service.httpcall('web_service/get_enquiry?FSchoolId=' + FSchoolId + '&FTypeId=' + FTypeId + '&FUserId=' + FUserId + '&Date=' + Date).subscribe(data => {
      loading.dismiss();
      console.log(data);
      this.EnqEnquiryData1 = data;
      this.EnqEnquiryData = this.EnqEnquiryData1;

      this.DataSearch = "";
    })
  }

  Enq_add_filter(f) {
    console.log(f);
    if (f == 'All') {
      this.FilterOption = 'All';
      this.DisplayDate = "";
      this.loadEnqvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
    } else {
      this.FilterOption = 'Date';
      var Date1 = new Date(this.Date);
      console.log(Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
      this.DisplayDate = Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
      console.log("DisplayDate ", this.DisplayDate);
      this.loadEnqvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
      console.log('Date call');
    }

  }

  Enq_Prev(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) - 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Enq_Next(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) + 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Enq_searchData(ev: any) {
    // Reset items back to all of the items
    this.EnqEnquiryData = this.EnqEnquiryData1;
    // set val to the value of the searchbar
    let val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.EnqEnquiryData = this.EnqEnquiryData.filter((item) => {
        return (item.Description.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }

  }

  Enq_go_to_call_logs(item) {
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage, {data: item, Tab: 3});
    // AppointmentModel.onDidDismiss(data => {
    //   console.log(data);
    // });
    Call_logs_model.present();
  }

  Enq_enquiry_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      cssClass: 'custom_alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {

            if (data != undefined) {
              console.log('Call clicked');
              console.log(data);
              console.log(JSON.parse(data));
              let UserDetails = JSON.parse(data);
              console.log(UserDetails.Name);
              console.log(UserDetails.Contact);
              console.log(enquirydata.Id);
              if (UserDetails.Contact != "" && UserDetails.Contact != undefined) {
                this.service.httpcall('web_service/add_call_history?FEnquiryId=' + enquirydata.Id + '&UserFullName=' + UserDetails.Name + '&Contact=' + UserDetails.Contact).subscribe(response_data => {

                  if (response_data['response'] == 'success') {
                    // this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
                    // window.location.href = 'tel:' + UserDetails.Contact;
                    // console.log('tel:' + UserDetails.Contact);
                    //window.open('tel:'+data);
                    // this.FCallHistoryId=data.FCallHistoryId;
                    let loading = this.loadingCtrl.create({
                      content: 'Loading',
                      enableBackdropDismiss: false
                    });
                    loading.present();


                    var formdata = new FormData();
                    formdata.append("FWebEnquiryId", enquirydata.FWebEnquiryId);
                    formdata.append("AddedBy", this.FUserId);
                    formdata.append("CallTo", UserDetails.Contact);
                    formdata.append("CallType", "2");
                    formdata.append("FileName", "text");
                    // formdata.append("CallFor",this.CallFor);


                    this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
                      console.log(resdata);
                      if (resdata['response'] == 'success') {
                        var LogId = resdata['LogId'];
                        if (loading)
                          loading.dismiss();
                        loading = undefined;

                        window.location.href = 'tel:' + data;
                        // var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+UserDetails.Contact+"?/&apn=com.example.callrecording";
                        // const browser = this.iab.create(link,'_system',{location:'no'});
                        // window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+UserDetails.Contact+"?/&apn=com.example.callrecording";
                      } else {
                        if (loading)
                          loading.dismiss();
                        loading = undefined;
                      }
                    }, (err) => {
                      if (loading)
                        loading.dismiss();
                      loading = undefined;
                    });
                  } else {
                    let toast = this.toastCtrl.create({
                      message: response_data['error_description'],
                      duration: 5000,
                      position: 'bottom'
                    });
                    toast.present();
                  }

                })
              }

            } else {
              let toast = this.toastCtrl.create({
                message: 'Please Select Contact',
                duration: 5000,
                position: 'bottom'
              });
              toast.present();
              return false;
            }


          }
        },
        {
          text: 'Add To Contact',
          handler: (phone_num) => {
            console.log(phone_num);
            if (phone_num != undefined) {
              console.log(JSON.parse(phone_num));
              let UserDetails = JSON.parse(phone_num);
              console.log(UserDetails.Name);
              console.log(UserDetails.Contact);

              let contact: Contact = this.contacts.create();
              //contact.name = new ContactName(null, FirstName, LastName);
              contact.name = new ContactName(null, UserDetails.Name, null);
              contact.phoneNumbers = [new ContactField('mobile', UserDetails.Contact)];
              contact.save().then(
                () => {
                  console.log('Contact saved!', contact);
                  let toast = this.toastCtrl.create({
                    message: 'Contact saved!',
                    duration: 5000,
                    position: 'middle'
                  });
                  toast.present();
                  return true;
                },
                (error: any) => {
                  console.error('Error saving contact.', error);
                  let toast = this.toastCtrl.create({
                    message: 'Error saving contact.',
                    duration: 5000,
                    position: 'middle'
                  });
                  toast.present();
                  return false;
                }
              );
            } else {
              let toast = this.toastCtrl.create({
                message: 'Please Select Contact',
                duration: 5000,
                position: 'bottom'
              });
              toast.present();
              return false;
            }


          }
        }
      ]
    });

    let FatherDetails = {Name: enquirydata.FatherName, Contact: enquirydata.Contact};
    let MotherDetails = {Name: enquirydata.MotherName, Contact: enquirydata.MotherContact};
    myAlert.addInput({
      type: 'radio',
      label: 'Father: ' + enquirydata.FatherName + ' (' + enquirydata.Contact + ')',
      value: JSON.stringify(FatherDetails)
    })
    myAlert.addInput({
      type: 'radio',
      label: 'Mother: ' + enquirydata.MotherName + ' (' + enquirydata.MotherContact + ')',
      value: JSON.stringify(MotherDetails)
    })
    myAlert.present();


  }

  Enq_whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);

            window.location.href = 'whatsapp://send?phone=+91' + data;


          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: 'Father: ' + enquirydata.FatherName + ' (' + enquirydata.Contact + ')',
      value: enquirydata.Contact
    })
    myAlert.addInput({
      type: 'radio',
      label: 'Mother: ' + enquirydata.MotherName + ' (' + enquirydata.MotherContact + ')',
      value: enquirydata.MotherContact
    })
    myAlert.present();


  }

  Enq_message_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);

            let loading = this.loadingCtrl.create({
              content: ''
            });
            loading.present();

            setTimeout(() => {
              loading.dismiss();
            }, 10000);

            let data1 = {
              Id: enquirydata.Id,
              FUserId: this.FUserId
            };
            console.log('data1', data1);

            this.service.httppostcall('web_service/get_enquiry_msg', data1).subscribe((result_data: any) => {
              loading.dismiss();
              if (result_data['status'] == 'success') {

                window.location.href = 'whatsapp://send?text=' + result_data['msg'] + '&phone=+91' + data + '&abid=+91' + data + '&url=' + result_data['msg'];

              } else {
                let toast = this.toastCtrl.create({
                  message: 'something went wrong',
                  duration: 5000,
                  position: 'middle'
                });
                toast.present();
              }
            });


          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: 'Father: ' + enquirydata.FatherName + ' (' + enquirydata.Contact + ')',
      value: enquirydata.Contact
    })
    myAlert.addInput({
      type: 'radio',
      label: 'Mother: ' + enquirydata.MotherName + ' (' + enquirydata.MotherContact + ')',
      value: enquirydata.MotherContact
    })
    myAlert.present();
  }

  Enq_status_click(item, eqId, FCallHistoryId, date) {
    console.log("FCallHistoryId", item.FCallHistoryId, item);
    console.log("date", item.date, item);
    let Record = this.modalCtrl.create(EnquirystatusPage, {
      "parentPage": this,
      eqId: item.Id,
      FCallHistoryId: item.FCallHistoryId,
      date: item.date
    });
    Record.present();
  }

  Enq_response_click(FEnquiryId) {
    let Record = this.modalCtrl.create(EnquiryresponsePage, {FEResponseId: FEnquiryId});
    Record.present();
  }

  Enq_goto_parent_feedback(enq) {
    let parent_feedback = this.modalCtrl.create(ParentFeedbackPage, {"parentPage": this, "FEnquiryId": enq.Id});
    parent_feedback.present();
    //this.navCtrl.push(ParentFeedbackPage, {"parentPage": this, "FEnquiryId": enq.Id})
  }

  Enq_goto_enquiry_remark(enq) {
    let enquiry_remark = this.modalCtrl.create(EnquiryRemarkPage, {"parentPage": this, "FEnquiryId": enq.Id});
    enquiry_remark.present();
  }

  Enq_msg_Group(item) {

    this.socialSharing.shareViaWhatsApp(item.Description, null, null);

  }

  Enq_shareContact(item) {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
      result => {
        console.log('Has permission?', result.hasPermission);

        if (result.hasPermission) {
          this.Enq_file_download(item);
        } else {
          this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE, this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE]);
          this.Enq_file_download(item);
        }
      },
      err => {
        console.log(err);
        this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE, this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE]);
        this.Enq_file_download(item);
      }
    );
  }

  Enq_file_download = function (img) {

    console.log(img);
    var imageName = 'SchoolOfficeNumber.vcf';
    var parts = imageName.split('.');
    console.log(parts);
    var title = parts[0];
    var ext = parts[1];
    var path = this.service.baseUrl + '/application/Contacts/SchoolOfficeNumber.vcf';

    var BasePath = (this.file.externalRootDirectory || this.file.documentsDirectory);


    this.file.checkFile(BasePath, this.SchoolName + "/" + title + "." + ext).then(result => {
      // Success!
      console.log('File Success!');
      var localPath = BasePath + this.SchoolName + "/" + title + "." + ext;
      console.log("localPath", localPath);
      //this.photoViewer.show(localPath, this.SubjectName, {share: false});
      //this.socialSharing.share("test", null, localPath, null);
      this.socialSharing.shareViaWhatsApp(null, localPath, null);
      //this.socialSharing.shareViaWhatsAppToReceiver('+918087226223', null, localPath, null);
    }, err => {
      // An error occured. Show a message to the user
      console.log('File Not Exist');
      console.log(err);

      const fileTransfer: FileTransferObject = this.transfer.create();

      const url = path;
      console.log(url);
      var device_path = (this.file.externalRootDirectory || this.file.documentsDirectory);
      var targetPath = device_path + this.SchoolName + "/" + title + "." + ext;
      console.log("targetPath", targetPath);
      fileTransfer.download(url, targetPath).then((entry) => {
        console.log('download complete: ' + entry.toURL());
        var contentType = '';
        console.log("ext", ext);
        this.socialSharing.shareViaWhatsApp(null, entry.toURL(), null);
        /*if (ext == 'pdf' || ext == 'PDF')
                 contentType='application/pdf';
                 else
                 contentType='image/'+ext;

                 console.log(contentType);
                 this.fileOpener.open(targetPath, contentType)
                 .then(() => console.log('File is opened'))
                 .catch(e => console.log('Error opening file', e));*/
        //this.photoViewer.show(targetPath, this.SubjectName, {share: false});
      }, (error) => {
        console.log("error", error);
      });
    });


  }

  Enq_add_SubStatus(item) {


    this.SubStatus = null;
    this.SubStatusItem = null;
    this.service.httpcall('web_service/get_master_enquiry_substatus?params[FStatusId]=' + item.StatusId).subscribe(data => {
      console.log("getReasons", data);
      if (data['response'] == "success") {
        this.SubStatus = data['data'];
        console.log(this.SubStatus);
        let myAlert = this.alertCtrl.create({
          title: 'Set SubStatus',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Confirm',
              handler: (data) => {
                console.log('clicked');
                console.log(data);

                this.service.httpcall('web_service/add_subStatus_On_webEnquiryId?FStatusId=' + item.StatusId + '&FWebEnquiryId=' + item.FWebEnquiryId + '&FUserId=' + this.FUserId + '&FSubStatusId=' + data).subscribe(data => {
                  console.log(data);
                  if (data['response'] == "success") {
                    this.presentToast(data['success_message']);
                    this.loadEnqvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);

                  } else {
                    this.presentToast(data['error_description']);
                  }

                }, (error2 => {
                  this.presentToast("Timeout!");
                }))

              }
            }
          ]
        });
        for (var i = 0; i < this.SubStatus.length; i++) {
          this.SubStatusItem = this.SubStatus[i];
          var edata = this.SubStatusItem.SubStatusName;
          console.log(edata);
          myAlert.addInput({
            type: 'radio',
            label: edata,
            value: this.SubStatusItem.Id
          })
        }

        myAlert.present();
      } else {
        this.presentToast(data['error_description']);

      }

    }, (error2 => {
      this.presentToast("Timeout!");

    }))


  }

  Enq_go_to_SubStatus_hist(item) {
    let SubStatusHistory = this.modalCtrl.create(SubStatusHistoryPage, {FWebEnquiryId: item.FWebEnquiryId});
    SubStatusHistory.onDidDismiss(data => {
      console.log(data);
    });
    SubStatusHistory.present();
  }

  Enq_select_archive(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Select Archive',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: (data) => {
            console.log('clicked');
            console.log(data);

            let loading = this.loadingCtrl.create({
              content: 'Loading'
            });
            loading.present();

            this.datanotfound = null;
            console.log("Id", item.FWebEnquiryId);
            this.service.httpcall('web_service/update_web_enquiry_as_testing?CancelledBy=' + this.FUserId + '&Id=' + item.FWebEnquiryId + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
              if (loading)
                loading.dismiss();
              loading = undefined;
              console.log(data);
              if (data['response'] == "success") {
                this.presentToast(data['success_message']);
                this.loadEnqvalues(this.SchoolData[this.School], this.statusbar, this.FUserId, this.DisplayDate);
              } else {
                this.datanotfound = data['error_description'];
              }
            })

          }
        }
      ]
    });
    for (var i = 0; i < this.ArchiveStatus.length; i++) {
      this.ArchiveStatusItem = this.ArchiveStatus[i];
      var edata = this.ArchiveStatusItem.Name;
      console.log(edata);
      myAlert.addInput({
        type: 'radio',
        label: edata,
        value: this.ArchiveStatusItem.Id
      })
    }

    myAlert.present();
  }


  searchData() {


    this.IsSearch = 1;

    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    // setTimeout(() => {
    //   loading.dismiss();
    // }, 5000);

    console.log("Search:", this.DataSearch);
    this.EnquiryData = [];
    this.datanotfound = null;

    let url = null;
    let status = this.StatusData[this.statusbar];
    if (status == 6) {
      url = 'web_service/get_webenquiry_by_search?FSchoolId=' + this.SchoolData[this.School] + '&FUserId=' + this.FUserId + '&Active=' + 3 + '&Search=' + this.DataSearch;
    } else {
      url = 'web_service/get_webenquiry_by_search?FSchoolId=' + this.SchoolData[this.School] + '&FUserId=' + this.FUserId + '&Active=' + 1 + '&Status=' + status + '&Search=' + this.DataSearch;
    }

    this.service.httpcall(url).subscribe(data => {

      if (loading)
        loading.dismiss();
      loading = undefined;

      console.log(data);
      if (data['response'] == "success") {
        if (loading)
          loading.dismiss();
        loading = undefined;
        this.datanotfound = null;
        this.EnquiryData = data['data'];
      } else {
        if (loading)
          loading.dismiss();
        loading = undefined;
        this.datanotfound = data['error_description'];
      }

    })
  }

  doInfinite(infiniteScroll) {
    if (this.IsSearch == 0) {
      console.log('Begin async operation');

      setTimeout(() => {
        // for (let i = 0; i < 30; i++) {
        //   this.items.push( this.items.length );
        // }
        this.page = this.page + 1;
        console.log("page number ", this.page);

        if (this.statusbar == 'All') {
          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        }
        if (this.statusbar == 'DataAdded') {
          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        }
        if (this.statusbar == 'AppointmentBooked') {
          this.Apmt_getReasons();
          this.loadApmtvalues(this.SchoolData[this.School], this.FUserId, this.AptStatusData[this.AptStatus], this.page);
        }
        if (this.statusbar == 'EnquiryAttended' && this.Enq_tab == 'All') {
          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        }
        if (this.statusbar == 'FeedbackSubmitted' && this.FbStatus == 'All') {
          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        }
        if (this.statusbar == 'AdmissionDone' && this.AdmStatus == 'AllADM') {
          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        }
        if (this.statusbar == 'Archive') {
          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
        }


        console.log('Async operation has ended');
        infiniteScroll.complete();
      }, 500);
    } else {
      console.log('Begin async operation');

      setTimeout(() => {
        // for (let i = 0; i < 30; i++) {
        console.log('Async operation has ended');
        infiniteScroll.complete();
      }, 500);
    }

  }

  enquiry_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            // window.location.href = 'tel:'  + data;
            let loading = this.loadingCtrl.create({
              content: 'Loading',
              enableBackdropDismiss: false
            });
            loading.present();


            var formdata = new FormData();
            formdata.append("FWebEnquiryId", enquirydata.Id);
            formdata.append("AddedBy", this.FUserId);
            formdata.append("CallTo", data);
            formdata.append("CallType", "2");
            formdata.append("FileName", "text");
            // formdata.append("CallFor",this.CallFor);


            this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
              console.log(resdata);
              if (resdata['response'] == 'success') {
                var LogId = resdata['LogId'];
                if (loading)
                  loading.dismiss();
                loading = undefined;

                window.location.href = 'tel:' + data;

                // var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
                // const browser = this.iab.create(link,'_system',{location:'no'});
                //  window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
              } else {
                if (loading)
                  loading.dismiss();
                loading = undefined;
              }
            }, (err) => {
              if (loading)
                loading.dismiss();
              loading = undefined;
            });

          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();
  }

  whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'whatsapp://send?phone=+91' + data;
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();


  }

  msg_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'sms:' + data;
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone1,
      value: enquirydata.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.Phone2,
      value: enquirydata.Phone2
    })
    myAlert.present();
  }

  msg_Group(item) {

    this.socialSharing.shareViaWhatsApp(item.SendWhatsAppGroupMsg, null, null);

  }

  SaveToContact(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Save',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            let contact: Contact = this.contacts.create();

            let EQDContactName = "EQD (" + item.Id + ")_" + item.StudentName;

            contact.name = new ContactName(null, EQDContactName, null);
            contact.phoneNumbers = [new ContactField('mobile', data)];
            contact.save().then(
              () => console.log('Contact saved!', contact),
              (error: any) => console.error('Error saving contact.', error)
            );
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();


  }

  add_contact(enquirydata) {
    let myAlert = this.alertCtrl.create({
      title: 'Add Contacts',
      cssClass: 'custom_alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Add To Contact',
          handler: (phone_num) => {
            console.log(phone_num);
            if (phone_num != undefined) {
              console.log(JSON.parse(phone_num));
              let UserDetails = JSON.parse(phone_num);
              console.log(UserDetails.Contact);
              let contactName = "EQD (" + enquirydata.Id + ") " + enquirydata.StudentName;
              console.log(contactName);
              let contact: Contact = this.contacts.create();
              //contact.name = new ContactName(null, FirstName, LastName);

              contact.name = new ContactName(null, 'Smith', 'John');
              contact.phoneNumbers = [new ContactField('mobile', '6471234567')];
              contact.save().then(
                () => console.log('Contact saved!', contact),
                (error: any) => console.error('Error saving contact.', error)
              );

            } else {
              let toast = this.toastCtrl.create({
                message: 'Please Select Contact',
                duration: 5000,
                position: 'bottom'
              });
              toast.present();
              return false;
            }


          }
        }
      ]
    });

    let Phone1 = {Contact: enquirydata.Phone1};
    let Phone2 = {Contact: enquirydata.Phone2};
    myAlert.addInput({
      type: 'radio',
      label: 'Phone1 :' + enquirydata.Phone1,
      value: JSON.stringify(Phone1)
    })
    myAlert.addInput({
      type: 'radio',
      label: 'Phone2: ' + enquirydata.Phone2,
      value: JSON.stringify(Phone2)
    })
    myAlert.present();
  }

  add_appointment(item) {

    let AppointmentModel = this.modalCtrl.create(AddAppointmentPage, {data: item});
    AppointmentModel.onDidDismiss(data => {
      console.log(data);

      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
      this.presentToast(data);
    });
    AppointmentModel.present();
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  send_WPappointment(item) {
    var link = "http://geis.co.in/add_appointment.php?FWebEnquiryId=" + item.Id + "&Name=" + item.StudentName;
    console.log(encodeURI(link));
    let myAlert = this.alertCtrl.create({
      title: 'Send Whatsapp Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            //window.location.href = 'whatsapp://send?phone=+91' + data+'&text='+this.sanitize(link);
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, "", null, encodeURI(link));
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();
  }

  send_Msgappointment(item) {
    var link = "http://geis.co.in/add_appointment.php?FWebEnquiryId=" + item.Id + "&Name=" + item.StudentName;
    console.log(encodeURI(link));
    let myAlert = this.alertCtrl.create({
      title: 'Send Text Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            //window.location.href = 'whatsapp://send?phone=+91' + data+'&text='+this.sanitize(link);
            this.socialSharing.shareViaSMS(encodeURI(link), '+91' + data);
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();
  }

  go_to_call_logs(item) {
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage, {data: item, Tab: 1});
    // AppointmentModel.onDidDismiss(data => {
    //   console.log(data);
    // });
    Call_logs_model.present();
  }

  edit_enquiry(item) {
    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {editData: item, IsAppointment: 0});
    EnquiryModel.onDidDismiss(data => {
      console.log(data);

      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
      this.presentToast(data);
    });
    EnquiryModel.present();
  }

  get_enquiry_log(item) {

    this.service.httpcall('web_service/get_web_enquiry_by_school_id?FWebEnquiryId=' + item.Id).subscribe(data => {

      console.log(data);
      if (data['response'] == "success") {
        let ListModel = this.modalCtrl.create(ListDataModelPage, {data: data['data'], title: "History"});
        ListModel.onDidDismiss(data => {
          console.log(data);

          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
          this.presentToast(data);
        });
        ListModel.present();
      } else {
        this.presentToast(data['error_description']);
      }

    })


  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.createFolderArcyle();
    // this.getPhoneNumber();
    this.getIncoming();
    this.getOutGoing();
    console.log('statusbar', this.statusbar, ' Enq_tab', this.Enq_tab);
    if (this.statusbar == 'AppointmentBooked') {
      this.AptStatusactive_tab(this.AptStatus);
    } else if (this.statusbar == 'EnquiryAttended' && this.Enq_tab != 'All') {
      this.loadEnqvalues(this.SchoolData[this.School], this.statusbar, this.FUserId, this.DisplayDate);
    } else if (this.statusbar == 'GuestJd') {
      this.active_GuestJd_tab(this.GuestJdSatus);
    } else {
      this.EnquiryData = [];
      this.page = 1;
      this.IsSearch = 0;
      this.DataSearch = null;
      this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
    }

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  show_siblings(item) {
    console.log(JSON.stringify(item))
  }

  load_archive_status() {
    this.ArchiveStatus = [];
    this.service.httpcall('web_service/get_master_archive_status?').subscribe(data => {
      this.ArchiveStatus = data;
    })
  }

  select_archive(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Select Archive',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: (data) => {
            console.log('clicked');
            console.log(data);

            let SchoolName = '';
            if (data == 1) {
              let myAlert1 = this.alertCtrl.create({
                title: 'Enter School Name',
                inputs: [
                  {
                    name: 'SchoolName',
                    placeholder: 'School Name'
                  },
                ],
                buttons: [
                  {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                      console.log('Cancel clicked');
                    }
                  },
                  {
                    text: 'Confirm',
                    handler: (data1) => {
                      console.log('clicked');
                      console.log(data1.SchoolName);
                      SchoolName = data1.SchoolName;

                      let loading = this.loadingCtrl.create({
                        content: 'Loading'
                      });
                      loading.present();

                      this.EnquiryData = [];
                      this.datanotfound = null;
                      console.log("Id", item.Id);
                      this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + '&Id=' + item.Id + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                        if (loading)
                          loading.dismiss();
                        loading = undefined;
                        console.log(data);
                        if (data['response'] == "success") {
                          this.presentToast(data['success_message']);
                          this.EnquiryData = [];
                          this.page = 1;
                          this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
                        } else {
                          this.datanotfound = data['error_description'];
                        }
                      })
                    }
                  }]
              });

              myAlert1.present();
              console.log("Archive1->", data);

            } else {
              let loading = this.loadingCtrl.create({
                content: 'Loading'
              });
              loading.present();

              this.EnquiryData = [];
              this.datanotfound = null;
              console.log("Id", item.Id);
              this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + '&Id=' + item.Id + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                if (loading)
                  loading.dismiss();
                loading = undefined;
                console.log(data);
                if (data['response'] == "success") {
                  this.presentToast(data['success_message']);
                  this.EnquiryData = [];
                  this.page = 1;
                  this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
                } else {
                  this.datanotfound = data['error_description'];
                }
              })
            }

          }
        }
      ]
    });
    for (var i = 0; i < this.ArchiveStatus.length; i++) {
      this.ArchiveStatusItem = this.ArchiveStatus[i];
      var edata = this.ArchiveStatusItem.Name;
      console.log(edata);
      myAlert.addInput({
        type: 'radio',
        label: edata,
        value: this.ArchiveStatusItem.Id
      })
    }

    myAlert.present();
  }

  add_SubStatus(item) {

    this.SubStatus = null;
    this.SubStatusItem = null;
    this.service.httpcall('web_service/get_master_enquiry_substatus?params[FStatusId]=' + item.Status).subscribe(data => {
      console.log("getReasons", data);
      if (data['response'] == "success") {
        this.SubStatus = data['data'];
        console.log(this.SubStatus);
        let myAlert = this.alertCtrl.create({
          title: 'Set SubStatus',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Confirm',
              handler: (data) => {
                console.log('clicked');
                console.log(data);

                this.service.httpcall('web_service/add_subStatus_On_webEnquiryId?FStatusId=' + item.Status + '&FWebEnquiryId=' + item.Id + '&FUserId=' + this.FUserId + '&FSubStatusId=' + data).subscribe(data => {
                  console.log(data);
                  if (data['response'] == "success") {
                    this.presentToast(data['success_message']);
                    this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate, this.StatusData[this.statusbar], this.page, this.DataSubstatustabData[this.DataSubstatustab], this.DataSourcetabData[this.DataSourcetab], this.ArchiveTypeData[this.ArchiveType], this.EnqSubData[this.EnqSub_tab]);
                  } else {
                    this.presentToast(data['error_description']);
                  }

                }, (error2 => {
                  this.presentToast("Timeout!");
                }))

              }
            }
          ]
        });
        for (var i = 0; i < this.SubStatus.length; i++) {
          this.SubStatusItem = this.SubStatus[i];
          var edata = this.SubStatusItem.SubStatusName;
          console.log(edata);
          myAlert.addInput({
            type: 'radio',
            label: edata,
            value: this.SubStatusItem.Id
          })
        }

        myAlert.present();
      } else {
        this.presentToast(data['error_description']);

      }

    }, (error2 => {
      this.presentToast("Timeout!");

    }))


  }

  go_to_SubStatus_hist(item) {
    let SubStatusHistory = this.modalCtrl.create(SubStatusHistoryPage, {FWebEnquiryId: item.Id});
    SubStatusHistory.onDidDismiss(data => {
      console.log(data);
    });
    SubStatusHistory.present();
  }

  openFab(socialNet: string, fab: FabContainer) {
    fab.close();
    if (socialNet == "AddEnq") {
      this.open_enquiry_form(null);
    }
    if (socialNet == "JustDialData") {
      this.Gust_open_JustDial_form(socialNet);
    }
    if (socialNet == "callLog") {
      this.navCtrl.setRoot(NonenquirylogPage);
    }
    if (socialNet == "dailylog") {
      this.navCtrl.setRoot(DailyCallLogsPage);
    }
  }

  //////////////////------------------------------------------------------------------------//////////////////////////

  getOutGoing() {
    let path = this.file.externalRootDirectory;

    //const date = moment().format("DD-MM-YYYY");

    this.file.listDir(path, 'ApplusCallRecording/Outgoing').then(data => {
      console.log(data);

      for (let i = 0; i < data.length; i++) {
        console.log(data[i]['nativeURL']);
        this.getoutgoingFile(data[i]['nativeURL'], data[i]['name']);
      }


    }).catch(err => {

      console.log(err);
    })
  }

  getoutgoingFile(filepath, filename) {

    this.file.resolveLocalFilesystemUrl(filepath).then((entry: any) => {
      entry.file((file1) => {
        console.log(file1);
        //alert('file1'+JSON.stringify(file1));
        const reader = new FileReader();

        reader.onloadend = () => {
          const formData = new FormData();
          const imgBlob = new Blob([reader.result], {type: file1.type});
          formData.append('uploadedfile', imgBlob, filename);
          formData.append('FileName', filename);
          formData.append('OutgoingNum', this.AllotedMobileNumber);
          formData.append('AddedBy', this.FUserId);
          // formData.append('FLogId', FcallId);
          this.upload_call_logs(formData, filename);
        };
        // this.save_event(formData,fileaname);
        reader.readAsArrayBuffer(file1);
      })
    }).catch((error) => {
      console.log('file error', error);
      const formData = new FormData();
      //this.save_event(formData,fileaname);
    })
  }

  upload_call_logs(formData, fileaname) {

    this.service.httppostFormcall('web_service/UpdateCallRecord', formData).subscribe(data => {

      console.log("add_document_files", data);
      if (data['status'] == "sucess") {

        console.log(data);
      } else {
        if (data['bit'] == '1') {
          //If File Exist Delete From Local
          this.moveFile('Outgoing', fileaname);
        }
        console.log(data);
      }
    });

  }

  open() {
    this.navCtrl.push(NonenquirylogPage);
  }

  //Function will check FileAvailable In Folder
  getIncoming() {
    let path = this.file.externalRootDirectory;

    //const date = moment().format("DD-MM-YYYY");

    this.file.listDir(path, 'ApplusCallRecording/Incoming').then(data => {
      console.log(data);

      for (let i = 0; i < data.length; i++) {
        console.log(data[i]['nativeURL']);
        this.getFile(data[i]['nativeURL'], data[i]['name']);
      }


    }).catch(err => {

      console.log(err);
    })
  }

  //Getting File From The Path
  getFile(filepath, filename) {

    let contactNumber = filename;

    this.file.resolveLocalFilesystemUrl(filepath).then((entry: any) => {
      entry.file((file1) => {
        console.log(file1);
        //alert('file1'+JSON.stringify(file1));
        const reader = new FileReader();


        //this method replace +91 and 0 from Number
        let Contact = filename;
        var code = '+91';
        var newstr = Contact.replace(code, "");
        var ContactString = newstr.replace(/\s/g, "");

        var getcall = ContactString.substring(0, 10);

        while (getcall.charAt(0) === '0') {
          getcall = getcall.substring(1);
        }

        reader.onloadend = () => {
          const formData = new FormData();
          const imgBlob = new Blob([reader.result], {type: file1.type});
          formData.append('uploadedfile', imgBlob, filename);
          formData.append('CallTo', this.AllotedMobileNumber);
          formData.append('CallFrom', getcall);
          formData.append('AddedBy', this.FUserId);
          formData.append('OutgoingNum', this.AllotedMobileNumber);
          formData.append('CallType', '1');
          // formData.append('FLogId', FcallId);
          this.uploadToServer(formData, filename);
        };
        // this.save_event(formData,fileaname);
        reader.readAsArrayBuffer(file1);
      })
    }).catch((error) => {
      console.log('file error', error);
      const formData = new FormData();
      const imgBlob = new Blob();
      formData.append('uploadedfile', imgBlob, '');
      // formData.append('FLogId', FcallId);
      let toast = this.toastCtrl.create({
        message: 'No Call Recorded...',
        duration: 1000
      });

      toast.present();
      //this.save_event(formData,fileaname);
    })
  }

  //This Will Upload To Serve
  uploadToServer(formData, filename) {
    // let loading=this.loadingCtrl.create({
    //   content:'Uploading ' +filename+' to server ...',
    // });

    //loading.present();

    console.log("event calling")

    this.service.httppostFormcall('web_service/incoming_enquiry_call_logs_with_record', formData).subscribe(data => {
      //loading.dismiss();
      console.log("add_document_files", data);
      if (data['response'] == "success") {

      } else {
        if (data['bit'] == '1') {
          //If File Exist Delete From Local
          this.moveFile('Incoming', filename);
        }


      }
    });
  }

  getNumber(filename) {
    let Contact = filename;
    var code = '+91';
    var newstr = Contact.replace(code, "");
    var ContactString = newstr.replace(/\s/g, "");
    var splitted = ContactString.substring(0, 10);
    console.log(splitted);
    return splitted;
  }

  Confirm_Upload_Call() {
    const date = moment().format("DD-MM-YYYY");

    let alert = this.alertCtrl.create({
      title: "Confirm!",
      message: "Upload Call Recording " + date,
      buttons: [
        {
          text: "No",
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: "Yes",
          handler: () => {
            this.getIncoming();
            //this.get_geolocation();
          }
        }
      ]
    });

    alert.present();
  }


  //get User Phone Number

  getPhoneNumber() {
    this.sim.getSimInfo().then(
      (info) => {
        this.simPhoneNumbers = info['cards'];
        console.log('Sim info: ', this.simPhoneNumbers);
        this.checkPermission()
      },
      (err) => console.log('Unable to get sim info: ', err)
    );


  }

  checkPermission() {
    this.sim.hasReadPermission().then(
      (info) => {
        console.log('Has permission: ', info)
        this.requestPermission()
      }
    );
  }

  requestPermission() {
    this.sim.requestReadPermission().then(
      (data) => {
        console.log('Permission granted')
        this.sim.getSimInfo().then(
          (info) => {
            this.simPhoneNumbers = info['cards'];
            console.log('Sim info check: ', this.simPhoneNumbers['phoneNumber']);
          },
          (err) => console.log('Unable to get sim info: ', err)
        );
        // this.getPhoneNumber();
      },
      () => console.log('Permission denied')
    );
  }

  moveFile(foldertype, filename) {

    //console.log(this.simPhoneNumbers[0]['phoneNumber']);

    let path = this.file.externalRootDirectory + "ApplusCallRecording/" + foldertype;

    let newpath = this.file.externalRootDirectory + "ApplusCallRecording/UploadedCall";


    this.file.moveFile(path, filename, newpath, filename).then(data => {
      console.log(data);
    }).catch(err => {

      console.log(err);
    })
  }


  createFolderArcyle() {
    /*Create Folder*/
    this.file.checkDir(this.file.externalRootDirectory + 'ApplusCallRecording', 'UploadedCall').then(response => {
      console.log('Directory exists' + response);
    }).catch(err => {
      console.log('Directory doesn\'t exist' + JSON.stringify(err));
      this.file.createDir(this.file.externalRootDirectory + 'ApplusCallRecording', 'UploadedCall', false).then(response => {
        console.log('Directory create' + response);
      }).catch(err => {
        this.checkPermissionStroage();
        console.log('Directory no create' + JSON.stringify(err));
      });
    });

    /*Create Folder*/

  }

  checkPermissionStroage() {
    console.log("Check Permission");
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(result => {
        //this.hasPermission = result.hasPermission;
        console.log('Has permission?', result['hasPermission']);
        if (result['hasPermission']) {
          console.log("Has Permission");
        } else {
          console.log("Deny Permission");
          this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
            console.log(result_data);
            if (result_data['hasPermission']) {
              console.log('Storage allow ', result_data['hasPermission']);
            } else {
              console.log('Storage deny ', result_data['hasPermission']);
            }
          }).catch((err) => {
            console.log("catch loop", JSON.stringify(err));
          });
        }
      },
      err => {
        this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
          console.log(result_data);
          console.log('error Has permission?', result_data['hasPermission']);
          if (result_data['hasPermission']) {
            console.log('err Storage allow ', result_data['hasPermission']);
          } else {
            console.log('err Storage deny ', result_data['hasPermission']);
          }
        }).catch((err) => {
          console.log(JSON.stringify(err));
        });
      });

  }

  go_to_add_reminder(item, Id, tap) {
    this.navCtrl.push(AddCallReminderPage, {
      'enquiry': item,
      'FCallStatusId': Id,
      'changeStatus': '0',
      'TapStatus': tap
    })
  }


  select_Unarchive(item) {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();

    console.log("Id", item.Id);
    this.service.httpcall('app_web_service/unArchive_EnquiryData?FUserId=' + this.FUserId + '&FWebEnquiryId=' + item.Id).subscribe(data => {
      if (loading)
        loading.dismiss();
      loading = undefined;
      console.log(data);
      if (data['response'] == "success") {
        this.presentToast(data['success_message']);
      } else {
        this.presentToast(data['error_description']);
      }
    })
  }

  //GuestJd
  active_GuestJd_tab(tab) {
    console.log(tab);
    this.GuestJdSatus = tab;
    this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
  }

  Gust_add_filter(f) {
    console.log(f);
    if (f == 'All') {
      this.FilterOption = 'All';
      this.DisplayDate = "";
      this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
    } else {
      this.FilterOption = 'Date';
      var Date1 = new Date(this.Date);
      console.log(Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
      this.DisplayDate = Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
      console.log("DisplayDate ", this.DisplayDate);
      this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
      console.log('Date call');
    }
  }

  Gust_Prev(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) - 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Gust_Next(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) + 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Gust_loadvalues(FSchoolId, FUserId) {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);
    this.EnquiryData = [];
    this.datanotfound = null;
    console.log("FSchoolId", FSchoolId);

    this.service.httpcall('web_service/get_guest_data?FSchoolId=' + FSchoolId + '&FUserId=' + FUserId + '&IsArchive=' + this.IsArchiveData[this.GuestJdSatus]).subscribe(data => {
      loading.dismiss();
      console.log(data);
      if (data['response'] == "success") {
        this.datanotfound = null;
        this.EnquiryData = data['data'];
      } else {
        this.datanotfound = data['error_description'];
      }

    })
  }


  Gust_open_enquiry_form2(item) {

    let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {dataPlus: item});
    // EnquiryModel.onDidDismiss(data => {
    //   console.log(data);
    //   // this.loadvalues(this.SchoolData[this.School], this.FUserId, this.DisplayDate);
    //   // this.presentToast(data);
    // });
    EnquiryModel.present();

  }

  Gust_open_call_logs(item) {
    if (item.CalllogCount != 0) {
      let loading = this.loadingCtrl.create({
        content: 'Loading'
      });
      loading.present();

      this.service.httpcall('app_web_service/get_predata_call_logs_by_predataid?FPredataId=' + item.Id).subscribe(data => {
        loading.dismiss();
        console.log(data);
        if (data['response'] == "success") {
          let Model = this.modalCtrl.create(PredataCallLogsPage, {data: data['data']});
          Model.present();
        } else {
          this.service.showAlert("Error!", data['error_description']);
        }
      }, error2 => {
        this.service.showAlert("Timeout!", "Refresh and Try again..");
      })
    }

  }

  Gust_enquiry_call(enquirydata) {

    console.log("item->", enquirydata);

    let myAlert = this.alertCtrl.create({
      title: 'Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Call',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            let loading = this.loadingCtrl.create({
              content: 'Loading'
            });
            loading.present();
            const jsondata = {
              'FPredataId': enquirydata.Id,
              'Contact': data,
              'AddedBy': this.FUserId,
              'AddedByName': this.userName
            }

            this.service.httppostcall('app_web_service/add_predata_call_logs?', jsondata).subscribe(res => {
              loading.dismiss();
              console.log(res);
              if (res['response'] == "success") {
                window.location.href = 'tel:' + data;
              } else {
                this.service.showAlert("Error!", res['error_description']);
              }
            }, error2 => {
              this.service.showAlert("Timeout!", "Refresh and Try again..");
            })
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MobileNumber,
      value: enquirydata.MobileNumber
    })
    myAlert.present();
  }

  Gust_whatsapp_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'whatsapp://send?phone=+91' + data;
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MobileNumber,
      value: enquirydata.MobileNumber
    })
    myAlert.present();


  }

  Gust_msg_call(enquirydata) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            window.location.href = 'sms:' + data;
          }
        }
      ]
    });
    myAlert.addInput({
      type: 'radio',
      label: enquirydata.MobileNumber,
      value: enquirydata.MobileNumber
    })
    myAlert.present();
  }

  Gust_msg_Group(item) {

    this.socialSharing.shareViaWhatsApp(item.SendWhatsAppGroupMsg, null, null);

  }

  Gust_addContact() {
    let contact: Contact = this.contacts.create();

    contact.name = new ContactName(null, 'Smith', 'John');
    contact.phoneNumbers = [new ContactField('mobile', '6471234567')];
    contact.save().then(
      () => console.log('Contact saved!', contact),
      (error: any) => console.error('Error saving contact.', error)
    );
  }

  Gust_add_contact(enquirydata) {
    let myAlert = this.alertCtrl.create({
      title: 'Add Contacts',
      cssClass: 'custom_alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Add To Contact',
          handler: (phone_num) => {
            console.log(phone_num);
            if (phone_num != undefined) {
              console.log(JSON.parse(phone_num));
              let UserDetails = JSON.parse(phone_num);
              console.log(UserDetails.Contact);
              let contactName = "EQD (" + enquirydata.Id + ") " + enquirydata.StudentName;
              console.log(contactName);
              let contact: Contact = this.contacts.create();
              //contact.name = new ContactName(null, FirstName, LastName);

              contact.name = new ContactName(null, 'Smith', 'John');
              contact.phoneNumbers = [new ContactField('mobile', '6471234567')];
              contact.save().then(
                () => console.log('Contact saved!', contact),
                (error: any) => console.error('Error saving contact.', error)
              );

              /*contact.name = new ContactName(null, contactName, null);
                             contact.phoneNumbers = [new ContactField('mobile', UserDetails.Contact)];
                             contact.save().then(
                             () =>{
                             console.log('Contact saved!', contact);
                             let toast = this.toastCtrl.create({
                             message: 'Contact saved!',
                             duration: 5000,
                             position: 'middle'
                             });
                             toast.present();
                             } ,
                             (error: any) => {
                             console.error('Error saving contact.', error);
                             let toast = this.toastCtrl.create({
                             message: 'Error saving contact.',
                             duration: 5000,
                             position: 'middle'
                             });
                             toast.present();
                             }
                             );*/

            } else {
              let toast = this.toastCtrl.create({
                message: 'Please Select Contact',
                duration: 5000,
                position: 'bottom'
              });
              toast.present();
              return false;
            }


          }
        }
      ]
    });

    let Phone1 = {Contact: enquirydata.Phone1};
    let Phone2 = {Contact: enquirydata.Phone2};
    myAlert.addInput({
      type: 'radio',
      label: 'Phone1 :' + enquirydata.Phone1,
      value: JSON.stringify(Phone1)
    })
    myAlert.addInput({
      type: 'radio',
      label: 'Phone2: ' + enquirydata.Phone2,
      value: JSON.stringify(Phone2)
    })
    myAlert.present();
  }

  Gust_add_appointment(item) {
    let AppointmentModel = this.modalCtrl.create(AddAppointmentPage, {data: item});
    AppointmentModel.onDidDismiss(data => {
      console.log(data);
      this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
      this.presentToast(data);
    });
    AppointmentModel.present();
  }

  Gust_sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  Gust_send_WPappointment(item) {
    var link = "http://geis.co.in/add_appointment.php?FWebEnquiryId=" + item.Id + "&Name=" + item.StudentName;
    console.log(encodeURI(link));
    let myAlert = this.alertCtrl.create({
      title: 'Send Whatsapp Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            //window.location.href = 'whatsapp://send?phone=+91' + data+'&text='+this.sanitize(link);
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, "", null, encodeURI(link));
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();
  }

  Gust_send_Msgappointment(item) {
    var link = "http://geis.co.in/add_appointment.php?FWebEnquiryId=" + item.Id + "&Name=" + item.StudentName;
    console.log(encodeURI(link));
    let myAlert = this.alertCtrl.create({
      title: 'Send Text Message',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Message',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            //window.location.href = 'whatsapp://send?phone=+91' + data+'&text='+this.sanitize(link);
            this.socialSharing.shareViaSMS(encodeURI(link), '+91' + data);
          }
        }
      ]
    });

    myAlert.addInput({
      type: 'radio',
      label: item.Phone1,
      value: item.Phone1
    })
    myAlert.addInput({
      type: 'radio',
      label: item.Phone2,
      value: item.Phone2
    })
    myAlert.present();
  }

  Gust_go_to_call_logs(item) {
    let Call_logs_model = this.modalCtrl.create(DataCallLogPage, {data: item});
    Call_logs_model.present();
  }

  // Gust_doRefresh(refresher) {
  //     console.log('Begin async operation', refresher);
  //
  //     this.loadvalues(this.SchoolData[this.School], this.FUserId);
  //     setTimeout(() => {
  //         console.log('Async operation has ended');
  //
  //         refresher.complete();
  //     }, 2000);
  // }


  // Gust_openFab(socialNet: string, fab: FabContainer) {
  //     fab.close();
  //     if (socialNet == "JustDialData") {
  //         this.Gust_open_JustDial_form(socialNet);
  //     }
  // }

  Gust_open_JustDial_form(item) {
    let Model = this.modalCtrl.create(AddJustdialDataPage);
    Model.onDidDismiss(data => {
      console.log(data);
      if (data == undefined) {
      } else {
        // this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
        this.presentToast(data);
      }


    });
    Model.present();
  }

  Gust_load_archive_status() {
    this.ArchiveStatus = [];
    this.service.httpcall('web_service/get_master_archive_status?').subscribe(data => {
      this.ArchiveStatus = data;
    })
  }

  Gust_select_archive(item) {
    let myAlert = this.alertCtrl.create({
      title: 'Select Archive',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: (data) => {
            console.log('clicked');
            console.log(data);

            let loading = this.loadingCtrl.create({
              content: 'Loading'
            });
            loading.present();

            this.EnquiryData = [];
            this.datanotfound = null;
            console.log("Id", item.Id);
            this.service.httpcall('web_service/archive_guest_app_login?Id=' + item.Id + '&IsJustDialData=' + item.IsJustDialData + '&ArchiveFor=' + data + '&ArchiveBy=' + this.FUserId).subscribe(data => {
              if (loading)
                loading.dismiss();
              loading = undefined;
              console.log(data);
              if (data['response'] == "success") {
                this.presentToast(data['success_message']);
                this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
              } else {
                const alert = this.alertCtrl.create({
                  title: 'Error!',
                  subTitle: data['error_description'],
                  buttons: ['OK']
                });
                alert.present();
              }
            })

          }
        }
      ]
    });
    for (var i = 0; i < this.ArchiveStatus.length; i++) {
      this.ArchiveStatusItem = this.ArchiveStatus[i];
      var edata = this.ArchiveStatusItem.Name;
      console.log(edata);
      myAlert.addInput({
        type: 'radio',
        label: edata,
        value: this.ArchiveStatusItem.Id
      })
    }

    myAlert.present();
  }

  Gust_predata_comment(item) {
    let alert = this.alertCtrl.create({
      title: 'Add Comment',
      inputs: [
        {
          name: 'Comment',
          placeholder: 'Comment'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'submit',
          handler: data => {
            console.log("data.Comment->", data.Comment)
            if (data.Comment) {
              let loading = this.loadingCtrl.create({
                content: 'Please wait...'
              });
              loading.present();

              this.service.httppostcall('app_web_service/add_comment_call_reminder_predata_by_id?FPredataId=' + item.Id + '&Comment=' + data.Comment, '').subscribe(data1 => {
                console.log(data1);
                if (data1['response'] == "success") {
                  loading.dismiss();
                  this.service.showToast(data1['message']);
                  this.Gust_loadvalues(this.SchoolData[this.School], this.FUserId);
                } else {
                  loading.dismiss();
                }
              }, (error2 => {
                loading.dismiss();
              }))
            } else {
              this.service.showToast("Enter Comment!");
            }

          }
        }
      ]
    });
    alert.present();
  }

  go_to_data_logs(item, tap) {
    let FWebEnquiryId = '';
    if (tap == 'Apmt') {
      FWebEnquiryId = item.FWebEnquiryId;
    } else {
      FWebEnquiryId = item.Id
    }

    let Model = this.modalCtrl.create(DataLogPage, {FWebEnquiryId: FWebEnquiryId, DataId: item.DataId});
    Model.present();
  }

  go_to_data_process_logs(item, tap) {
    let FWebEnquiryId = '';
    if (tap == 'Apmt') {
      FWebEnquiryId = item.FWebEnquiryId;
    } else {
      FWebEnquiryId = item.Id
    }
    this.service.showToast("Coming Soon");
    //
    // let Model = this.modalCtrl.create(DataLogPage, {FWebEnquiryId: FWebEnquiryId,DataId:item.DataId});
    // Model.present();
  }

  go_to_data_reminder_logs(item, tap) {
    let FWebEnquiryId = '';
    if (tap == 'Apmt') {
      FWebEnquiryId = item.FWebEnquiryId;
    } else {
      FWebEnquiryId = item.Id
    }

    this.service.showToast("Coming Soon");
    //
    // let Model = this.modalCtrl.create(DataLogPage, {FWebEnquiryId: FWebEnquiryId,DataId:item.DataId});
    // Model.present();
  }

  open_actionsheet(tap, item) {
    console.log("tap->", tap);

    let buttons = [];

    let CallCount = '0';
    if (item.CallCount != 0) {
      CallCount = item.CallCount;
    }

    let Callbtn1 = {
      text: this.service.LabelCall + ' (' + CallCount + ')',
      icon: this.service.IconCall,
      handler: () => {
        console.log(this.service.LabelCall);
        if (tap == 'Apmt') {
          this.Apmt_enquiry_call(item);
        } else {
          this.enquiry_call(item);
        }

      }
    }
    buttons.push(Callbtn1);

    let CallLogbtn2 = {
      text: this.service.LabelCallLogs,
      icon: this.service.IconCallLogs,
      handler: () => {
        console.log(this.service.LabelCallLogs);
        if (tap == 'Apmt') {
          this.Apmt_go_to_call_logs(item);
        } else {
          this.go_to_call_logs(item);
        }

      }
    }
    buttons.push(CallLogbtn2);

    let DataLogbtn2 = {
      text: this.service.LabelDataLogs,
      icon: this.service.IconDataLogs,
      handler: () => {
        console.log(this.service.LabelDataLogs);
        this.go_to_data_logs(item, tap);

      }
    }
    buttons.push(DataLogbtn2);

    let DataLogReminderbtn2 = {
      text: this.service.LabelDataReminderLogs,
      icon: this.service.IconDataReminderLogs,
      handler: () => {
        console.log(this.service.LabelDataReminderLogs);
        this.go_to_data_reminder_logs(item, tap);

      }
    }
    buttons.push(DataLogReminderbtn2);

    let DataLogProcessbtn2 = {
      text: this.service.LabelDataProcessLogs,
      icon: this.service.IconDataProcessLogs,
      handler: () => {
        console.log(this.service.LabelDataProcessLogs);
        this.go_to_data_process_logs(item, tap);

      }
    }
    buttons.push(DataLogProcessbtn2);

    let SendWhatsAppbtn3 = {
      text: this.service.LabelSendWpMsg,
      icon: this.service.IconSendWpMsg,
      handler: () => {
        console.log(this.service.LabelSendWpMsg);
        if (tap == 'Apmt') {
          this.Apmt_whatsapp_call(item);
        } else {
          this.whatsapp_call(item);
        }
      }
    }
    buttons.push(SendWhatsAppbtn3);

    if (item.Status == 1) {
      let btn1 = {
        text: this.service.LabelAddApt,
        icon: this.service.IconAddApt,
        handler: () => {
          console.log(this.service.LabelAddApt);
          this.add_appointment(item);
        }
      }
      buttons.push(btn1);

      let btn2 = {
        text: this.service.LabelSendApt,
        icon: this.service.IconSendApt,
        handler: () => {
          console.log(this.service.LabelSendApt);
          this.send_WPappointment(item);
        }
      }
      buttons.push(btn2);

      let btn3 = {
        text: this.service.LabelSendMsgApt,
        icon: this.service.IconSendMsgApt,
        handler: () => {
          console.log(this.service.LabelSendMsgApt);
          this.send_Msgappointment(item);
        }
      }
      buttons.push(btn3);
    }

    if (tap == 'Apmt') {
      let btn1 = {
        text: this.service.LabelSendAptMsgWp,
        icon: this.service.IconSendAptMsgWp,
        handler: () => {
          console.log(this.service.LabelSendAptMsgWp);
          this.Apmt_send_whatsapp(item);
        }
      }
      buttons.push(btn1);

      let btn2 = {
        text: this.service.LabelSendAptMsgSMS,
        icon: this.service.IconSendAptMsgSMS,
        handler: () => {
          console.log(this.service.LabelSendAptMsgSMS);
          this.Apmt_send_msg(item);
        }
      }
      buttons.push(btn2);

      let btnSend = {
        text: this.service.LabelSendAptMsgSMSOnGrp,
        icon: this.service.IconSendAptMsgSMSOnGrp,
        handler: () => {
          this.Apmt_msg_Group(item);
        }
      }
      buttons.push(btnSend);

      let btn3 = {
        text: this.service.LabelResApt,
        icon: this.service.IconResApt,
        handler: () => {
          console.log(this.service.LabelResApt);
          this.Apmt_rescheduleApmt(item);
        }
      }
      buttons.push(btn3);

      let btn4 = {
        text: this.service.LabelCancelApt,
        icon: this.service.IconCancelApt,
        handler: () => {
          console.log(this.service.LabelCancelApt);
          this.Apmt_cancelApmt(item);
        }
      }
      buttons.push(btn4);
    }

    let edit = {
      text: this.service.LabelEditData,
      icon: this.service.IconEditData,
      handler: () => {
        console.log(this.service.LabelEditData);
        if (tap == 'Apmt') {
          this.Apmt_edit_enquiry(item);
        } else {
          this.edit_enquiry(item);
        }
      }
    }
    buttons.push(edit);

    let Hist = {
      text: this.service.LabelEditHistory,
      icon: this.service.IconEditHistory,
      handler: () => {
        console.log(this.service.LabelEditHistory);
        if (tap == 'Apmt') {
          this.Apmt_get_enquiry_log(item);
        } else {
          this.get_enquiry_log(item);
        }
      }
    }
    buttons.push(Hist);

    if (tap == 'All' || tap == 'Data' || tap == 'Enq' || tap == 'Fb' || tap == 'Adm') {
      let AddSib = {
        text: this.service.LabelAddSib,
        icon: this.service.IconAddSib,
        handler: () => {
          console.log(this.service.LabelAddSib);
          this.open_enquiry_form(item);
        }
      }
      buttons.push(AddSib);

      let SendLocation = {
        text: this.service.LabelSendLoc,
        icon: this.service.IconSendLoc,
        handler: () => {
          console.log(this.service.LabelSendLoc);
          this.send_location(item);
        }
      }
      buttons.push(SendLocation);
    }

    if (item.IsArchive != 1) {
      let btn = {
        text: this.service.LabelArchiveData,
        icon: this.service.IconArchiveData,
        handler: () => {
          console.log(this.service.LabelArchiveData);
          if (tap == 'Apmt') {
            this.Apmt_select_archive(item);
          } else {
            this.select_archive(item);
          }
        }
      }
      buttons.push(btn);
    }

    let AddSubStatus = {
      text: this.service.LabelAddSubStatus,
      icon: this.service.IconAddSubStatus,
      handler: () => {
        console.log(this.service.LabelAddSubStatus);
        if (tap == 'Apmt') {
          this.Apmt_add_SubStatus(item);
        } else {
          this.add_SubStatus(item);
        }
      }
    }
    buttons.push(AddSubStatus);

    let SubStatusHist = {
      text: this.service.LabelSubStatusHist,
      icon: this.service.IconSubStatusHist,
      handler: () => {
        console.log(this.service.LabelSubStatusHist);
        if (tap == 'Apmt') {
          this.Apmt_go_to_SubStatus_hist(item);
        } else {
          this.go_to_SubStatus_hist(item);
        }
      }
    }
    buttons.push(SubStatusHist);


    let AddReminder = {
      text: this.service.LabelAddCallRem,
      icon: this.service.IconAddCallRem,
      handler: () => {
        console.log(this.service.LabelAddCallRem);
        this.go_to_add_reminder(item, 4, tap);
      }
    }
    buttons.push(AddReminder);

    let Cancel = {
      text: this.service.LabelCancel,
      icon: this.service.IconCancel,
      handler: () => {
        console.log(this.service.LabelCancel);
      }
    }
    buttons.push(Cancel);

    this.presentActionSheet('Actions', buttons);

  }

  open_ArchiveActionSheet(tap, item) {
    console.log("tap->", tap);

    let buttons = [];

    let CallCount = '0';
    if (item.CallCount != 0) {
      CallCount = item.CallCount;
    }

    let btn1 = {
      text: this.service.LabelCall + ' (' + CallCount + ')',
      icon: this.service.IconCall,
      handler: () => {
        console.log(this.service.LabelCall);
        this.enquiry_call(item);
      }
    }
    buttons.push(btn1);

    let btn2 = {
      text: this.service.LabelCallLogs,
      icon: this.service.IconCallLogs,
      handler: () => {
        console.log(this.service.LabelCallLogs);
        this.go_to_call_logs(item);
      }
    }
    buttons.push(btn2);

    let btn3 = {
      text: this.service.LabelSendWpMsg,
      icon: this.service.IconSendWpMsg,
      handler: () => {
        console.log(this.service.LabelSendWpMsg);
        this.whatsapp_call(item);
      }
    }
    buttons.push(btn3);

    let btn4 = {
      text: this.service.LabelSendTextMsg,
      icon: this.service.IconSendTextMsg,
      handler: () => {
        console.log(this.service.LabelSendTextMsg);
        this.msg_call(item);
      }
    }
    buttons.push(btn4);

    let btn5 = {
      text: this.service.LabelSendWpGrp,
      icon: this.service.IconSendWpGrp,
      handler: () => {
        console.log(this.service.LabelSendWpGrp);
        this.msg_Group(item);
      }
    }
    buttons.push(btn5);

    let btn6 = {
      text: this.service.LabelEditData,
      icon: this.service.IconEditData,
      handler: () => {
        console.log(this.service.LabelEditData);
        this.edit_enquiry(item);
      }
    }
    buttons.push(btn6);

    let btn7 = {
      text: this.service.LabelEditHistory,
      icon: this.service.IconEditHistory,
      handler: () => {
        console.log(this.service.LabelEditHistory);
        this.get_enquiry_log(item);
      }
    }
    buttons.push(btn7);

    let btn8 = {
      text: this.service.LabelUnArchiveData,
      icon: this.service.IconUnArchiveData,
      handler: () => {
        console.log(this.service.LabelUnArchiveData);
        this.select_Unarchive(item);
      }
    }
    buttons.push(btn8);

    let btn9 = {
      text: this.service.LabelAddSubStatus,
      icon: this.service.IconAddSubStatus,
      handler: () => {
        console.log(this.service.LabelAddSubStatus);
        this.add_SubStatus(item);
      }
    }
    buttons.push(btn9);

    let btn10 = {
      text: this.service.LabelSubStatusHist,
      icon: this.service.IconSubStatusHist,
      handler: () => {
        console.log(this.service.LabelSubStatusHist);
        this.go_to_SubStatus_hist(item);
      }
    }
    buttons.push(btn10);

    let Cancel = {
      text: this.service.LabelCancel,
      icon: this.service.IconCancel,
      handler: () => {
        console.log(this.service.LabelCancel);
      }
    }
    buttons.push(Cancel);


    this.presentActionSheet('Actions', buttons);
  }

  presentActionSheet(title, buttons) {
    const actionSheet = this.actionSheetCtrl.create({
      title: title,
      buttons
    });
    actionSheet.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts